import { IDropFileModel } from "../types/common";
import {
  selectedItemGroupsKey,
  selectedManufacturersKey,
} from "../utils/imageMatcherUtil";

export const useUploadedImages = () => {
  const uploadedImagesKey = "uploadedImages";

  const getImageById = (imageId: string | null | undefined) => {
    const uploadedImages = handleGetUploadedImages();
    return uploadedImages.find((x) => x.id === imageId);
  };

  const isDisplayBack = () => {
    return handleGetUploadedImages().length === 1;
  };

  const handleGetUploadedImages = () => {
    return JSON.parse(
      localStorage.getItem(uploadedImagesKey) || "[]"
    ) as IDropFileModel[];
  };

  const handleSetUploadedImages = (newUploadedImages: IDropFileModel[]) => {
    localStorage.setItem(uploadedImagesKey, JSON.stringify(newUploadedImages));
  };

  const handleClearUploadedImages = () => {
    localStorage.removeItem(uploadedImagesKey);
    localStorage.removeItem(selectedItemGroupsKey);
    localStorage.removeItem(selectedManufacturersKey);
  };

  return {
    handleGetUploadedImages,
    handleSetUploadedImages,
    handleClearUploadedImages,
    getImageById,
    isDisplayBack,
  };
};
